import { render, staticRenderFns } from "./edite.vue?vue&type=template&id=56cb50be&scoped=true&"
import script from "./edite.vue?vue&type=script&lang=ts&"
export * from "./edite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cb50be",
  null
  
)

export default component.exports